import HomeNavChatPane from './HomeNavChatPane'
import HomeNavPulsePane from './HomeNavPulsePane'
import { NAV_MODE } from './navMode.js'
import styles from './HomeNavRail.module.scss'

function paneClass(active) {
  return `${styles.paneLayer}${active ? '' : ` ${styles.paneLayerInactive}`}`
}

/** Keep both panes mounted so the Chat/Pulse chrome above does not reflow. */
export default function HomeNavRailPanes({ mode, ctx, groups, schedule }) {
  const rows = {
    selectedThreadId: ctx.selectedThreadId,
    onSelectThread: ctx.onThreadSelect,
    onThreadMenuAction: ctx.onThreadMenuAction,
    onRenameThread: ctx.onRenameThread,
  }
  const chatOn = mode === NAV_MODE.CHAT
  const pulseOn = mode === NAV_MODE.PULSE

  return (
    <div className={styles.panes}>
      <div className={paneClass(chatOn)} aria-hidden={!chatOn} inert={!chatOn}>
        <HomeNavChatPane
          pinnedThreads={groups.pinnedThreads}
          threads={groups.chatThreads}
          allThreads={ctx.threads}
          onNewChat={ctx.onNewChat}
          {...rows}
        />
      </div>
      <div className={paneClass(pulseOn)} aria-hidden={!pulseOn} inert={!pulseOn}>
        <HomeNavPulsePane
          {...ctx}
          workflows={groups.scheduledWorkflows}
          schedule={schedule}
        />
      </div>
    </div>
  )
}
